module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar-default navbar-static-side",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "sidebar-collapse"
  }, [_c('ul', {
    staticClass: "nav metismenu",
    attrs: {
      "id": "side-menu"
    }
  }, [_c('li', {
    staticClass: "nav-header"
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/logo-side-menu.png"),
      "alt": "Arrow Logistics"
    }
  }), _vm._v(" "), _c('p', [_c('strong', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$user.profile.full_name))]), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$user.profile.company_name))]), _c('br')]), (_vm.$user.isDisabled) ? _c('div', {
    staticClass: "m-t-md navigation-disabled-warning",
    attrs: {
      "role": "alert",
      "data-toggle": "modal",
      "data-target": ".modal-disabled-help"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Account Disabled\n          ")]) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), (_vm.$user.canManageJobRequests) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'jobs.requests'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-question-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Job Requests")]), _vm._v(" "), (_vm.pendingJobRequests) ? _c('span', {
    staticClass: "label pull-right"
  }, [_vm._v(_vm._s(_vm.pendingJobRequests))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageJobBoard) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'job-board.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-bullhorn"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Job Board")])])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageJobs) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'jobs.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-truck"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Jobs")])])]) : _vm._e(), _vm._v(" "), (_vm.$user.isCarrier) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'loads.requests'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-question-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Load Requests")]), _vm._v(" "), (_vm.loadRequests) ? _c('span', {
    staticClass: "label pull-right"
  }, [_vm._v(_vm._s(_vm.loadRequests))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageLocations) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'locations.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-map-signs"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Locations")])])]) : _vm._e(), _vm._v(" "), (_vm.$user.canSeeMap) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'map'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-map-marked"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Map")])])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageTrucks) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'trucks.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-truck-container"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("My Trucks")])])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageDrivers) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'drivers.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-id-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("My Drivers")])])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageLoads) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'loads.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-clipboard-list"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Loads")]), _vm._v(" "), (_vm.loadsWithIssues) ? _c('span', {
    staticClass: "label pull-right",
    staticStyle: {
      "margin": "0 1px 0 1px"
    }
  }, [_vm._v(_vm._s(_vm.loadsWithIssues))]) : _vm._e(), _vm._v(" "), (_vm.withdrawnLoads) ? _c('span', {
    staticClass: "label pull-right",
    staticStyle: {
      "margin": "0 1px 0 1px"
    }
  }, [_vm._v(_vm._s(_vm.withdrawnLoads))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageLoadChecks) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'load-check.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Load Check")]), _vm._v(" "), (_vm.pendingLoadChecks) ? _c('span', {
    staticClass: "label pull-right"
  }, [_vm._v(_vm._s(_vm.pendingLoadChecks))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageInvoices) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'invoices.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-file-invoice"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Invoices")]), _vm._v(" "), (_vm.outstandingInvoices) ? _c('span', {
    staticClass: "label pull-right"
  }, [_vm._v(_vm._s(_vm.outstandingInvoices))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManagePayments) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'payments.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-money-check-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Payments")]), _vm._v(" "), (_vm.paymentsNeedingInvoice) ? _c('span', {
    staticClass: "label pull-right"
  }, [_vm._v(_vm._s(_vm.paymentsNeedingInvoice))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageReports) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'reports.index'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "far fa-fw fa-analytics"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Reports")])])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageUsers) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "far fa-fw fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Users ")]), _vm._v(" "), _c('span', {
    staticClass: "fa arrow"
  }), _vm._v(" "), (_vm.usersPendingVerification) ? _c('span', {
    staticClass: "label pull-right",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.usersPendingVerification))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-second-level collapse"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users.index'
      }
    }
  }, [_vm._v("Active Users")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users.pending'
      }
    }
  }, [_vm._v("\n            Pending Users\n            ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$user.canManageSettings) ? _c('li', [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-second-level collapse"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings.system'
      }
    }
  }, [_vm._v("System Settings")])], 1)])]) : _vm._e(), _vm._v(" "), _c('li'), _c('li', {
    class: {
      'active': _vm.active('account')
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-second-level collapse",
    class: {
      'in': _vm.active('account')
    },
    attrs: {
      "aria-expanded": _vm.active('account')
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'account.settings'
      }
    }
  }, [_c('a', [_vm._v("Account Settings")])]), _vm._v(" "), (_vm.$user.isMaster) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'account.users'
      }
    }
  }, [_c('a', [_vm._v("Account Users")])]) : _vm._e(), _vm._v(" "), (_vm.$user.isNotAdmin) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'account.notifications'
      }
    }
  }, [_c('a', [_vm._v("Notifications")])]) : _vm._e()], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "far fa-fw fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Settings")]), _c('span', {
    staticClass: "fa arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "far fa-fw fa-user-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Account")]), _c('span', {
    staticClass: "fa arrow"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-72963f51"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/Navigation.vue
// module id = 1038
// module chunks = 0